import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { Church, Wine } from "lucide-react";

export default function Program() {
  const { t } = useLang();

  const items = [
    {
      icon: Church,
      time: t.program.ceremony.time,
      title: t.program.ceremony.title,
      testid: "program-ceremony",
    },
    {
      icon: Wine,
      time: t.program.party.time,
      title: t.program.party.title,
      testid: "program-party",
    },
  ];

  return (
    <section
      id="program"
      className="relative py-24 md:py-40 px-6 md:px-12"
      data-testid="program-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="text-xs uppercase tracking-[0.4em] text-burgundy mb-4"
          >
            {t.program.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.1, delay: 0.1 }}
            className="font-serif font-light text-4xl md:text-6xl text-ink"
          >
            {t.program.title}
          </motion.h2>
        </div>

        <div className="relative max-w-2xl mx-auto">
          {/* Centered vertical line */}
          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.4 }}
            className="absolute left-1/2 -translate-x-1/2 top-6 bottom-6 w-[1px] bg-wedding-border origin-top"
          />

          <div className="flex flex-col gap-16 md:gap-24 relative">
            {items.map((it, i) => (
              <motion.div
                key={it.testid}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1, delay: i * 0.2 }}
                className="relative flex flex-col items-center text-center"
                data-testid={it.testid}
              >
                {/* Node */}
                <div className="relative z-10 w-12 h-12 rounded-full bg-ivory border border-wedding-border flex items-center justify-center mb-5 shadow-[0_4px_12px_rgba(114,47,55,0.08)]">
                  <it.icon size={18} className="text-burgundy" />
                </div>

                <span
                  className="font-serif text-5xl md:text-6xl text-burgundy leading-none mb-3"
                  data-testid={`${it.testid}-time`}
                >
                  {it.time}
                </span>
                <h3 className="font-serif font-light text-2xl md:text-3xl text-ink">
                  {it.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
